module.exports = __webpack_public_path__ + "img/e_3_21_g.425f2dac.png";